import * as React from "react";
import {UIState} from "../../data/UIState";
import './ExtTopper.pcss';
import {WellnessConceptsLogo} from "../widgets/WellnessConceptsLogo";

export const ExtTopper = () =>
    <div className={"ext-topper"}>
      <div className="logo-container"><WellnessConceptsLogo /></div>
      <div className="company-name">{UIState.settings.COMPANY_NAME}</div>
    </div>
;
